export const VIEW_MODES = {
  OUTLOOK: "outlook",
};
